export default __webpack_public_path__ + "static/jinhwanchoi-211374b836953b691fa57c57b09427b7.jpeg";